/* Reopen Shopify's native privacy preferences from its generated policy link. */
(() => {
  if (window.lignonPrivacyBound) return;
  window.lignonPrivacyBound = true;
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[href="#shopifyReshowConsentBanner"]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const status = document.querySelector('[data-ln-privacy-status]');
    try {
      if (!window.privacyBanner?.showPreferences) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      await window.privacyBanner.showPreferences();
      if (status) status.textContent = '';
    } catch (error) {
      if (status) {
        status.classList.remove('visually-hidden');
        status.textContent = document.documentElement.lang.startsWith('fr')
          ? 'Les préférences de cookies ne peuvent pas être chargées. Veuillez réessayer.'
          : 'Cookie preferences could not be loaded. Please try again.';
      }
    }
  }, true);
})();
